module.exports = __webpack_public_path__ + "img/mentoring-md.cdbc6126.jpg";